var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "line2slots flex-level" }, [
    _c(
      "p",
      {
        staticClass: "m-0 gray-80",
        class: [{ title: _vm.isTitle }, { subtitle: _vm.isSubtitle }]
      },
      [_vm._t("left")],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "flex-right" }, [
      _c(
        "p",
        {
          staticClass: "m-0 gray-80",
          class: [{ title: _vm.isTitle }, { subtitle: _vm.isSubtitle }]
        },
        [_vm._t("right")],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }